export const getTicketInformation = ({ tickets, addons = [] }, id) => {
  const ticket = tickets.find((ticket) => ticket.id === id);

  if (ticket) {
    return {
      ...ticket,
      addons: addons.filter(
        ({ associated_tickets: associatedTickets, standalone }) =>
          !standalone && associatedTickets.includes(ticket.id),
      ),
    };
  }
};

export const getSelectedCurrency = ({ event, tickets }) => {
  const selectedTickets = tickets.filter(
    ({ quantity }) => Number(quantity) > 0,
  );

  if (selectedTickets.length === 0) {
    return;
  }

  const { id } =
    selectedTickets.find(({ isFree }) => !isFree) || selectedTickets[0];

  return getTicketInformation(event, id).currency;
};
